



























































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'
import { User, Role, Branch, Business } from '@/utils/types'
import {
  checkIfEmailIsValid,
  checkIfPhoneIsValid,
  checkIfEmailIsAvailable,
  checkIfPhoneIsAvailable
} from '@/utils/helpers'

@Component
export default class EmployerCrud extends Vue {
  @Prop(String) title!: string;
  @Prop(Object) user?: User;
  data?: User;

  isEmailTaken = false;
  isPhoneTaken = false;
  showPass = false;

  statuses = [
    { value: null, text: 'ממתין' },
    { value: true, text: 'מאושר' },
    { value: false, text: 'נדחה' }
  ];

  rules = {
    isEmailValid: (value: string) =>
      checkIfEmailIsValid(value) || 'אימייל לא תקין',
    isPhoneValid: (value: string) =>
      checkIfPhoneIsValid(value) || 'מספר טלפון לא תקין',
    min8chars: (value: string) => value.length >= 8 || 'לפחות 8 תווים',
    requiredField: (value: string) => !!value || 'שדה חובה'
  };

  @Watch('user')
  onUserPropChange () {
    this.data = {
      id: this.user?.id ?? '',
      address: this.user?.address ?? '',
      birthday: this.user?.birthday,
      business: {
        address: this.user?.business?.address ?? '',
        businessNumber: this.user?.business?.businessNumber ?? '',
        branch: {
          name: this.user?.business?.branch?.name ?? ''
        } as Branch,
        certificateImage: this.user?.business?.certificateImage ?? '',
        isApproved: this.user?.business?.isApproved ?? null,
        name: this.user?.business?.name ?? ''
      } as Business,
      email: this.user?.email ?? '',
      firstName: this.user?.firstName ?? '',
      image: this.user?.image ?? '',
      lastName: this.user?.lastName ?? '',
      password: '',
      phone: this.user?.phone ?? '',
      role: this.user?.role ?? Role.AUTHENTICATED
    }
  }

  constructor () {
    super()
    this.onUserPropChange()
  }

  async checkEmailAvailability () {
    const email = this.data?.email || ''
    if (checkIfEmailIsValid(email)) {
      this.isEmailTaken = !(await checkIfEmailIsAvailable(email))
      return
    }
    this.isEmailTaken = false
  }

  async checkPhoneAvailability () {
    const phone = this.data?.phone || ''
    if (checkIfPhoneIsValid(phone)) {
      this.isPhoneTaken = !(await checkIfPhoneIsAvailable(phone))
      return
    }
    this.isPhoneTaken = false
  }

  emitClose () {
    this.$emit('close')
  }

  async emitSubmit () {
    if (this.data?.password === '') {
      delete this.data.password
    }
    this.$emit('submit', this.data)
  }

  get isFormVisible () {
    return (
      !!this.user
    )
  }
}
